import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const { Types, Creators } = createActions({
	// Sagas
	geoBuscarPorAlertaId: ['alertaId', 'callback'],

	// Reducer
	geoBuscarPorAlertaIdReducer: ['geo'],
});

export const INITIAL_STATE_VALUES = {
	responsavel: '',
	dataAcao: undefined,
	responsavelEmissao: '',
	dataHoraEmissao: undefined,
	geo: {
		id: 0,
		alertaId: 0,
		municipios: [],
		areaDesenhada: {},
	},
};

const INITIAL_STATE = Immutable(Object.assign({}, INITIAL_STATE_VALUES));

const geoBuscarPorAlertaIdReducer = (state = INITIAL_STATE, action) => state.merge(
	{
		responsavel: action.data.responsavel,
		dataAcao: action.data.dataAcao,
		responsavelEmissao: action.data.responsavelEmissao,
		dataHoraEmissao: action.data.dataHoraEmissao,
		geo: { ...action.geo },
	},
);

export default createReducer(INITIAL_STATE, {
	[Types.GEO_BUSCAR_POR_ALERTA_ID_REDUCER]: geoBuscarPorAlertaIdReducer,
});
